import Axios from 'axios';
import type { ListBrokerageDTO } from '@bb/domain/dist/types/dto/ListingController/listBrokerage';
import type { ParsedListing } from '@bb/domain/dist/types/dto/commonTypes';

type GetListingsOptions = {
  subscriptionType: 'org' | 'user';
  userId?: string;
  // for search && pagination.
  address: string; // search term
  pageNumber: number;
  // for sorting ability
  sort_field?: string;
  sort_asc?: 'true' | 'false';
  // for filters
  locations?: string[];
  availability?: string[];
  useAppointmentDesk?: boolean[];
};

const getListingsForAppointmentDesk = async ({
  subscriptionType,
  userId,
  address,
  pageNumber,
  sort_field,
  sort_asc,
  locations,
  availability,
  useAppointmentDesk,
}: GetListingsOptions): Promise<{
  count: number;
  limit: number;
  page: number;
  listings: ParsedListing[];
}> => {
  const { data } = await Axios.get<ListBrokerageDTO>(
    `/listing/appointment_desk/${pageNumber}`,
    {
      params: {
        subscriptionType,
        userId,
        address,
        sort_field,
        sort_asc,
        locations,
        avail: availability,
        useAppointmentDesk,
        searchType: 'appointmentDesk',
      },
    },
  );
  return data;
};

export default getListingsForAppointmentDesk;
